import { _normalize, collectionCommand } from 'volta/utils/api';

import Task, { TaskCommands } from './task';
import type { TPOStatus, TPOValidationStatus } from 'volta/models/types/planning-order';
import type {
  ICreateTaskCmd,
  IDeleteTaskCmd,
  IReopenTaskCmd,
  IResolveTaskCmd,
  IUpdateTaskCmd
} from './types/tasks';
import { Type } from '@warp-drive/core-types/symbols';

interface ILinkedEntityPayload {
  skuId: string;
  partCode: string;
  skuDescription?: string;
  warehouseCode: string;
  dueDate: string;
  reorderQty: number;
  unitMeasure: string;
  status: TPOStatus;
  validationStatus?: TPOValidationStatus;
  orderNum?: string;
  orderLine?: string;
}

export default class PoTask extends Task<Record<string, any>, ILinkedEntityPayload> {
  /**
   * Commands
   */

  static createTask = collectionCommand<ICreateTaskCmd, PoTask, typeof PoTask>(
    TaskCommands.CreateTask,
    {
      ajaxOptions: { queryParams: { include: 'createdBy,resolvedBy,assignees' } }
    }
  );

  static updateTask = collectionCommand<IUpdateTaskCmd, PoTask, typeof PoTask>(
    TaskCommands.UpdateTask
  );

  static deleteTask = collectionCommand<IDeleteTaskCmd, void, typeof PoTask>(
    TaskCommands.DeleteTask
  );

  static resolveTask = collectionCommand<IResolveTaskCmd, PoTask, typeof PoTask>(
    TaskCommands.ResolveTask
  );

  static reopenTask = collectionCommand<IReopenTaskCmd, PoTask, typeof PoTask>(
    TaskCommands.ReopenTask
  );
  // @ts-ignore
  [Type] = 'po-task' as const;
  static modelNAme = 'po-task';
}
